const LoadingSpinner = () => <img src="/images/tail-spin.gif" alt={'LOADING...'}/>;

export default LoadingSpinner;
